import * as React from 'react'
import { cn } from '@/lib/utils'

/* A multi-line TextField (design board 07): the input's outline, focus and
   error treatment, 88 high by default and growing with its content. */
function Textarea({ className, ...props }: React.ComponentProps<'textarea'>) {
  return (
    <textarea
      data-slot="textarea"
      className={cn(
        'border-border-control bg-surface text-foreground placeholder:text-muted-foreground flex field-sizing-content min-h-22 w-full rounded-md border px-3 py-2 text-sm transition-[border-color,box-shadow] outline-none',
        'hover:border-foreground-secondary focus-visible:border-focus-ring focus-visible:shadow-focus-halo focus-visible:outline-none',
        'aria-invalid:border-error',
        'disabled:bg-surface-muted disabled:border-border disabled:text-foreground-disabled disabled:cursor-not-allowed',
        className,
      )}
      {...props}
    />
  )
}

export { Textarea }
